;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var Model            = APP.module('Model'),
		tooltip_template = _.template(
			'<div class="tooltip-wrapper pull-right left"><i class="tooltip-icon pointer fa fa-info-circle"></i><div class="tooltip"><div class="tooltip-inner">' +
			'<h4><%= title %></h4><p><%= content %></p></div><div class="tooltip-arrow"></div></div></div>'
		),
		field_template   = _.template('' +
			'<div class="field-set clearfix">' +
			'<div class="field-title" ><%= title %></div>' +
			' <div class="filed-elem" data-editor></div>' +
			' <div class="field-help" ><%= help %></div>' +
			'</div>'
		);

	Model.TippingLeague = Model.League.extend({
		api_prefix: 'tipping',
		defaults: {
			name:        '',
			privacy:     'private',
			start_round: 1,
			//coaches_box: 1,
			league_avatar: ''
		},
		schema: {
			//League settings
			name: {
				title: 'Name your comp*',
				validators: [
					{ type: 'required', message: 'Comp name - is required field' }
				],
				fieldClass: 'platform-form-field clearfix',
				help: tooltip_template({
					title: 'Comp name',
					content: 'Max of 40 characters. Inappropriate comp names will be deleted and replaced with your team name.'
				}),
				template:field_template
			},
			privacy: {
				type: 'Radio',
				title: 'Privacy settings',
				options: [
					{ label: 'Private', val: 'private'},
					{ label: 'Public', val: 'public'}
				],
				fieldClass: 'platform-form-field clearfix',
				help: tooltip_template({
					title: 'Privacy settings',
					content: 'Private comps can only be joined via invite or comp code. Public comps are ' +
					'available for anyone to join.'
				})
			},
			start_round: {
				type: 'Select',
				title: 'Starting week',
				options: [],
				fieldClass: 'platform-form-field clearfix',
				help: tooltip_template({
					title: 'Comp start week',
					content: 'This can be changed to select any week as your preferred start week provided it is a ' +
					'valid week based on other configurable comp settings.'
				}),
				template: field_template
			},
			//coaches_box: {
			//	type: 'Radio',
			//	title: 'Turn on coaches box?',
			//	options: [
			//		{ label: 'On', val: 1},
			//		{ label: 'Off', val: 0}
			//	],
			//	fieldClass: 'platform-form-field clearfix',
			//	help: tooltip_template({
			//		title: 'Coaches Box',
			//		content: 'Turn on/off Coaches Box chat feature for the comp.'
			//	})
			//},
			avatar: {
				type: "LeagueImagePicker",
				template: JST.LeagueImageUploader,
				options:{
					default_img_url: CONFIG.IMAGES_URL+'nouserpic.png',
					button_text: 'EDIT IMAGE'
				}
			}
		},
		add_celebrities: function(ids) {
			return this.setApiUrl('_celebrity/join')
				.save({}, {
					data: { league_id: this.get('id'), users: ids },
					success: _.bind(function(model, resp) {
						if (resp.errors.length) {
							this.trigger('leagues:errors', resp.errors);
						}
						else {
							this.trigger('leagues:add_celebrities:success', ids);
						}
					}, this)
				});
		}
	});

}(window, APP, Backbone, Marionette, $, _));